import React from "react";
import _ from "lodash";
import { CgMenuGridR } from "react-icons/cg";
import { FiX } from "react-icons/fi";
import { FaExchangeAlt, FaShieldAlt } from "react-icons/fa";
import NetworkEnsureResourcesModal from "components/ops-mgmt/account/NetworkEnsureResourcesModal";
import UnitIdExchangerModal from "./tool-box/UnitIdExchangerModal";

const TOOL = {
  UNIT_ID_EXCHANGER: "UNIT_ID_EXCHANGER",
  ENSURE_RESOURCES: "ENSURE_RESOURCES",
};

const STATUS = {
  IN_PROCESS: "IN_PROCESS",
  SUCCESS: "SUCCESS",
  FAILED: "FAILED",
};

const LOADING_STYLE = { "--loader-size": "1.125rem", "--color": "#3182ce" };

class ToolBoxWidget extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      isOpenView: false,

      selectedTool: null,
      networkId: null,
      networkName: null,

      processObj: {},
    };

    this.handleSelectTool = this.handleSelectTool.bind(this);
    this.handleToolClose = this.handleToolClose.bind(this);
    this.handleEnsureProcessClose = this.handleEnsureProcessClose.bind(this);
    this.handleEnsureProcessStart = this.handleEnsureProcessStart.bind(this);
    this.handleCloseHint = this.handleCloseHint.bind(this);
    this.handleCheckProcess = this.handleCheckProcess.bind(this);
  }

  // Click tool widget
  handleSelectTool(tool) {
    if (tool === TOOL.ENSURE_RESOURCES) {
      const { dataRef } = this.props;
      if (!dataRef || !dataRef.current) return;

      const network = dataRef.current.getNetwork();
      const networkId = _.get(network, "mainId");
      const networkName = _.get(network, "mainTitle", "");

      if (_.isNil(networkId)) return;
      this.handleCheckProcess({ networkId, name: networkName });
    } else if (tool === TOOL.UNIT_ID_EXCHANGER) {
      this.setState({ selectedTool: tool });
    }
  }

  // For closing other tool modal
  handleToolClose() {
    this.setState({
      selectedTool: null,
      networkId: null,
      networkName: null,
    });
  }

  // For closing "Ensure Resources" modal
  handleEnsureProcessClose() {
    this.setState((prevState) => {
      const { processObj, networkId } = prevState;
      const updatedProcessObj = { ...processObj };
      const processData = updatedProcessObj[networkId];
      if (processData && processData.status === STATUS.IN_PROCESS) {
        updatedProcessObj[networkId] = {
          ...processData,
          isModalOpen: false,
        };
      } else {
        delete updatedProcessObj[networkId];
      }

      return {
        selectedTool: null,
        networkId: null,
        networkName: null,
        processObj: updatedProcessObj,
      };
    });
  }

  async handleEnsureProcessStart({ execfunc, networkId, name } = {}) {
    if (typeof execfunc !== "function") return;

    const isProcessing =
      _.get(this.state.processObj, [networkId, "status"]) === STATUS.IN_PROCESS;

    if (isProcessing) return;

    let processResult = null;

    try {
      this.setState((prevState) => ({
        processObj: {
          ...prevState.processObj,
          [networkId]: {
            name,
            status: STATUS.IN_PROCESS,
            data: null,
            isModalOpen: true,
          },
        },
      }));
      processResult = await execfunc();
    } catch (error) {
      processResult = {
        error: error.toString(),
      };
    } finally {
      const resultMsg = _.get(processResult, "result");

      // Detect modal is open or not and check the network id
      const modalChecked =
        this.state.selectedTool === TOOL.ENSURE_RESOURCES &&
        this.state.networkId === networkId;

      this.setState((prevState) => ({
        processObj: {
          ...prevState.processObj,
          [networkId]: {
            name,
            status: resultMsg === "OK" ? STATUS.SUCCESS : STATUS.FAILED,
            data: processResult,
            isModalOpen: modalChecked,
          },
        },
      }));
    }
  }

  // Click "Check" in hint box
  handleCheckProcess({ networkId, name }) {
    const { processObj } = this.state;
    const processData = processObj[networkId];

    const stateData = {
      networkName: name || "",
    };

    if (!_.isNil(processData)) {
      const updatedProcessObj = { ...processObj };
      const networkName = name || processData.name || "";
      updatedProcessObj[networkId] = {
        ...processData,
        name: networkName,
        isModalOpen: true,
      };
      stateData.processObj = updatedProcessObj;
      stateData.networkName = networkName;
    }

    this.setState({
      selectedTool: TOOL.ENSURE_RESOURCES,
      networkId: _.toInteger(networkId),
      ...stateData,
    });
  }

  // Click "Dismiss" in hint box
  handleCloseHint(networkId) {
    const { processObj } = this.state;
    const updatedProcessObj = { ...processObj };
    delete updatedProcessObj[networkId];
    this.setState({ processObj: updatedProcessObj });
  }

  render() {
    const { processObj, isOpenView, selectedTool, networkId, networkName } =
      this.state;

    return (
      <div className="pointer-events-auto flex flex-col items-end gap-3">
        {_.keys(processObj).map((networkId) => {
          const processData = processObj[networkId];
          if (processData.isModalOpen) return null;

          return (
            <div
              className="border rounded flex flex-col gap-2 border-blue-400 bg-gray-200 px-3 py-2 text-sm shadow-md"
              key={networkId}
            >
              <div className="border-b flex items-center gap-2 border-gray-400 pb-1 pr-2 text-gray-800">
                <div>
                  <HintMessage
                    status={processData.status}
                    name={processData.name}
                    networkId={networkId}
                  />
                </div>
                {processObj[networkId].status === STATUS.IN_PROCESS && (
                  <div className="loader" style={LOADING_STYLE}></div>
                )}
              </div>
              <div className="flex items-center justify-end gap-2">
                <div
                  className="border cursor-pointer rounded-full border-blue-400 bg-blue-600 px-2 text-xs text-gray-200 hover:bg-blue-700"
                  onClick={() => this.handleCheckProcess({ networkId })}
                >
                  Check
                </div>
                {[STATUS.SUCCESS, STATUS.FAILED].includes(
                  processObj[networkId].status,
                ) && (
                  <div
                    className="border cursor-pointer rounded-full border-blue-400 bg-blue-600 px-2 text-xs text-gray-200 hover:bg-blue-700"
                    onClick={() => this.handleCloseHint(networkId)}
                  >
                    Dismiss
                  </div>
                )}
              </div>
            </div>
          );
        })}

        {isOpenView ? (
          <div className="border rounded flex cursor-pointer flex-col border-blue-400 bg-gray-200 px-4 py-2 text-sm shadow-md">
            <div
              className="border ml-auto cursor-pointer rounded-full border-gray-400 p-1 text-gray-700 hover:text-blue-600"
              onClick={() => this.setState({ isOpenView: false })}
            >
              <FiX />
            </div>
            <div className="mb-2 flex w-full gap-2">
              <ToolItem
                tooltext="Unit ID Exchanger"
                onClick={() => this.handleSelectTool(TOOL.UNIT_ID_EXCHANGER)}
              >
                <FaExchangeAlt />
              </ToolItem>
              <ToolItem
                tooltext="Ensure Resources"
                onClick={() => this.handleSelectTool(TOOL.ENSURE_RESOURCES)}
              >
                <FaShieldAlt />
              </ToolItem>
            </div>
          </div>
        ) : (
          <div
            className="border cursor-pointer rounded-full border-gray-300 bg-gray-100 p-2 text-2xl text-blue-600 shadow-md hover:bg-gray-200"
            onClick={() =>
              this.setState({
                isOpenView: true,
              })
            }
          >
            <CgMenuGridR />
          </div>
        )}

        {selectedTool === TOOL.UNIT_ID_EXCHANGER && (
          <UnitIdExchangerModal
            onClose={this.handleToolClose}
          ></UnitIdExchangerModal>
        )}

        {selectedTool === TOOL.ENSURE_RESOURCES && (
          <NetworkEnsureResourcesModal
            networkId={networkId}
            name={networkName}
            process={processObj}
            backgroundProcess={true}
            handleClose={this.handleEnsureProcessClose}
            handleProcess={this.handleEnsureProcessStart}
          ></NetworkEnsureResourcesModal>
        )}
      </div>
    );
  }
}

function ToolItem({ children, tooltext = "", onClick = () => {} }) {
  return (
    <div
      className="group flex flex-1 cursor-pointer flex-col items-center gap-2"
      onClick={onClick}
    >
      <div className="border flex items-center justify-center rounded-full border-gray-400 p-2 text-lg text-gray-700 shadow-md group-hover:border-blue-400 group-hover:text-blue-600">
        {children}
      </div>

      <div className="break-words text-center text-xs font-semibold leading-none text-gray-600">
        {tooltext}
      </div>
    </div>
  );
}

function HintMessage({ status, name, networkId }) {
  let message = "";
  if (status === STATUS.IN_PROCESS) {
    message = "Ensuring resources...";
  } else if (status === STATUS.SUCCESS) {
    message = (
      <span className="text-green-700">Resources ensured successfully.</span>
    );
  } else if (status === STATUS.FAILED) {
    message = <span className="text-red-700">Failed to ensure resources.</span>;
  }

  return (
    <>
      <b>
        [{networkId} - {name}]{" "}
      </b>
      {message}
    </>
  );
}

export default ToolBoxWidget;
